@use "~theme/typographyV2" as typography;
@use "~theme/breakpoints";

.container {
  background: var(--white);
  border-radius: 8px;
  box-shadow: 0 2px 6px var(--gray-03);
  color: var(--blue-01);
  font-family: typography.$font-mont;
  margin: 0 0 8px;
  padding: 10px 12px;

  @include breakpoints.desktop {
    border-radius: 20px;
    margin-bottom: 12px;
    padding: 14px 16px;
  }
}

.heading {
  color: var(--brand-indigo);
  font-family: typography.$font-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.3px;
  line-height: 31px;
  margin: 0;
  overflow-wrap: anywhere;

  @include breakpoints.desktop {
    font-size: 32px;
    line-height: 41px;
    overflow-wrap: normal;
  }
}

.detail {
  @include typography.caption;
  color: var(--blue-02);
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  margin: 3px 0 0;

  @include breakpoints.desktop {
    font-size: 18px;
    line-height: 29px;
    margin-top: 6px;
  }

  strong {
    font-weight: 700;
  }
}
